'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('./_virtual/_rollupPluginBabelHelpers.js');
var getClientStorage = _interopDefault(require('@narvar/client-storage'));
var apolloCacheInmemory = require('apollo-cache-inmemory');
var apolloCachePersist = require('apollo-cache-persist');
var apolloClientFactory = require('./apolloClientFactory.js');

var apolloClientFactoryUnpersisted = function apolloClientFactoryUnpersisted() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      name = _ref.name,
      connectToDevTools = _ref.connectToDevTools,
      uri = _ref.uri,
      maxRetryAttempts = _ref.maxRetryAttempts,
      maxBatch = _ref.maxBatch,
      batchInterval = _ref.batchInterval,
      cacheTtlMins = _ref.cacheTtlMins,
      cacheTtlCheckMs = _ref.cacheTtlCheckMs,
      restLinks = _ref.restLinks,
      fetch = _ref.fetch,
      ssrMode = _ref.ssrMode,
      link = _ref.link,
      disablePersistedCache = _ref.disablePersistedCache,
      initialState = _ref.initialState,
      addTypename = _ref.addTypename,
      fragmentMatcher = _ref.fragmentMatcher;

  return apolloClientFactory.default({
    name: name,
    connectToDevTools: connectToDevTools,
    uri: uri,
    maxRetryAttempts: maxRetryAttempts,
    maxBatch: maxBatch,
    batchInterval: batchInterval,
    cacheTtlMins: cacheTtlMins,
    cacheTtlCheckMs: cacheTtlCheckMs,
    restLinks: restLinks,
    fetch: fetch,
    ssrMode: ssrMode,
    link: link,
    disablePersistedCache: disablePersistedCache,
    initialState: initialState,
    addTypename: addTypename,
    fragmentMatcher: fragmentMatcher
  });
};

var apolloClientFactoryPersisted = /*#__PURE__*/function () {
  var _ref2 = _rollupPluginBabelHelpers.asyncToGenerator( /*#__PURE__*/_rollupPluginBabelHelpers.regeneratorRuntime().mark(function _callee() {
    var _ref3,
        name,
        connectToDevTools,
        uri,
        maxRetryAttempts,
        maxBatch,
        batchInterval,
        cacheTtlMins,
        cacheTtlCheckMs,
        _ref3$restLinks,
        restLinks,
        fetch,
        _ref3$ssrMode,
        ssrMode,
        link,
        _ref3$disablePersiste,
        disablePersistedCache,
        initialState,
        _ref3$addTypename,
        addTypename,
        fragmentMatcher,
        cache,
        clientStorage,
        persistor,
        _args = arguments;

    return _rollupPluginBabelHelpers.regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref3 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, name = _ref3.name, connectToDevTools = _ref3.connectToDevTools, uri = _ref3.uri, maxRetryAttempts = _ref3.maxRetryAttempts, maxBatch = _ref3.maxBatch, batchInterval = _ref3.batchInterval, cacheTtlMins = _ref3.cacheTtlMins, cacheTtlCheckMs = _ref3.cacheTtlCheckMs, _ref3$restLinks = _ref3.restLinks, restLinks = _ref3$restLinks === void 0 ? {} : _ref3$restLinks, fetch = _ref3.fetch, _ref3$ssrMode = _ref3.ssrMode, ssrMode = _ref3$ssrMode === void 0 ? false : _ref3$ssrMode, link = _ref3.link, _ref3$disablePersiste = _ref3.disablePersistedCache, disablePersistedCache = _ref3$disablePersiste === void 0 ? false : _ref3$disablePersiste, initialState = _ref3.initialState, _ref3$addTypename = _ref3.addTypename, addTypename = _ref3$addTypename === void 0 ? false : _ref3$addTypename, fragmentMatcher = _ref3.fragmentMatcher;
            cache = new apolloCacheInmemory.InMemoryCache({
              addTypename: addTypename,
              fragmentMatcher: fragmentMatcher
            });

            if (initialState) {
              cache = cache.restore(initialState);
            }

            clientStorage = getClientStorage();
            persistor = null;

            if (!((typeof window === "undefined" ? "undefined" : _rollupPluginBabelHelpers.typeof(window)) === 'object' && clientStorage && !disablePersistedCache)) {
              _context.next = 9;
              break;
            }

            persistor = new apolloCachePersist.CachePersistor({
              cache: cache,
              // TODO: Remove type assertion when `apollo-cache-persist` gets updated to
              // version `>=0.2.0`.
              storage: clientStorage
            });
            _context.next = 9;
            return persistor.restore();

          case 9:
            return _context.abrupt("return", apolloClientFactory.default({
              name: name,
              connectToDevTools: connectToDevTools,
              uri: uri,
              maxRetryAttempts: maxRetryAttempts,
              maxBatch: maxBatch,
              batchInterval: batchInterval,
              cacheTtlMins: cacheTtlMins,
              cacheTtlCheckMs: cacheTtlCheckMs,
              restLinks: restLinks,
              fetch: fetch,
              ssrMode: ssrMode,
              link: link,
              disablePersistedCache: disablePersistedCache,
              initialState: initialState,
              addTypename: addTypename,
              fragmentMatcher: fragmentMatcher,
              cache: cache,
              persistor: persistor
            }));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function apolloClientFactoryPersisted() {
    return _ref2.apply(this, arguments);
  };
}();

exports.CACHE_TTL_CHECK_MS = apolloClientFactory.CACHE_TTL_CHECK_MS;
exports.CACHE_TTL_MINS = apolloClientFactory.CACHE_TTL_MINS;
exports.MAX_BATCH = apolloClientFactory.MAX_BATCH;
exports.MAX_RETRY_ATTEMPTS = apolloClientFactory.MAX_RETRY_ATTEMPTS;
exports.apolloClientFactory = apolloClientFactoryUnpersisted;
exports.default = apolloClientFactoryPersisted;
//# sourceMappingURL=index.js.map
